<template>
  <component @click="$emit('click')" :class="{ 'disabled': c_disabled, 'error': error, 'loading': loading, 'success': success }" :disabled="c_disabled" :is="element" :theme="theme">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'roosh-button',
  props: {
    disabled: Boolean,
    error: Boolean,
    loading: Boolean,
    success: Boolean,
    element: {
      type: String,
      default: 'd-button',
    },
    theme: {
      type: String,
      default: 'primary',
    }
  },
  computed: {
    c_disabled () {
      return this.disabled || this.loading;
    },
  },
}
</script>
